import { useState } from "react";
import { JsonViewer } from '@textea/json-viewer';
import { FILEURL, TOAST_TYPES } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import { useTranslation } from "../../locale/useTranslation";

const PdfToJson = () => {

    const lang = useTranslation();
    const [formData, setFormData] = useState(null);
    const [jsonData, setJsonData] = useState(null);

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        setFormData(formData);
    }

    const handleDownlodJson = async () => {
        if (!formData) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a file to upload" });
        }
        const response = await fetch("http://localhost:3000/v2/file/readPdf", {
            method: "POST",
            body: formData
        });
        const res = await response.json();
        console.log(res.data);
        window.open(FILEURL().BASEURL + 'downloadCSV/' + res.data);
        if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <div>
            <input name="file" type="file" accept="application/pdf" onChange={handleFileUpload} />
            <button className="btn btn-success" onClick={handleDownlodJson}>
                Convert to CSV
            </button>
            <button className="btn btn-danger" onClick={handleDownlodJson}>
                Convert 
            </button>

        </div >
    )
}

export default PdfToJson;